"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ButtonLabel = void 0;
var react_1 = __importDefault(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
var ButtonLabel = function (_a) {
    var className = _a.className, _b = _a.as, as = _b === void 0 ? 'span' : _b, rest = __rest(_a, ["className", "as"]);
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as, className: ['button_label', className] }, rest)));
};
exports.ButtonLabel = ButtonLabel;
//# sourceMappingURL=ButtonLabel.js.map